// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"EditItemSidebar_sidebarContainer__milSV","sidebarContent":"EditItemSidebar_sidebarContent__foUs7"};